import React from "react";
import { connect } from "react-redux";

import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";

import Typography from "@material-ui/core/Typography";
import Checkbox from "../../../../../ui/Checkbox";
import TextField from "@material-ui/core/TextField";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

import { changeModuleScheduleAction } from "../../../store/actions";

const useStyles = makeStyles({
  title: {
    display: "block",
    fontSize: "14px",
    lineHeight: "18px",
    marginBottom: "16px"
  },
  caption: {
    fontSize: "14px",
    lineHeight: "18px",
    marginBottom: "16px"
  }
});

const CalendarSchedule = ({
  allModuleVolume,
  moduleSchedule,
  changeModuleSchedule
}) => {
  const { caption, title } = useStyles();

  const [volume, setVolume] = React.useState(allModuleVolume);

  const changeSchedule = (field, value) => {
    let obj = { ...moduleSchedule };
    obj.data[field] = value;
    changeModuleSchedule(obj);
  };

  const changeWeek = (i, event) => {
    const values = [...allModuleVolume];
    values[i].week = event.target.value;
    setVolume(values);
  };

  const isAuto =
    moduleSchedule && moduleSchedule.data && moduleSchedule.data.calcWeek;

  return (
    <Grid container direction="column">
      <span className={title}>Календарный учебный график</span>
      <Grid item style={{ marginBottom: 43 }}>
        <Checkbox
          label="Автоматический расчёт количества недель"
          checked={isAuto || false}
          handleChange={e => changeSchedule("calcWeek", e.target.checked)}
        />
      </Grid>
      <Grid item>
        <Typography className={caption}>Порядок освоения разделов</Typography>
      </Grid>
      <Grid item>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="left" style={{ width: 125 }}>
                  <Typography>№ недели</Typography>
                </TableCell>
                <TableCell align="left">
                  <Typography>Раздел</Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {allModuleVolume.map((volume, idx) => (
                <TableRow key={volume.id}>
                  <TableCell style={{ padding: "8px 16px" }}>
                    <TextField
                      value={volume.week || ""}
                      inputProps={{ style: { textAlign: "center" } }}
                      disabled={isAuto}
                      onChange={e => changeWeek(idx, e)}
                    />
                  </TableCell>
                  <TableCell style={{ padding: "8px 16px" }}>
                    <Typography
                      style={{
                        color: isAuto ? "lightgray" : "#000"
                      }}
                    >
                      {volume.name}
                    </Typography>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
};

const mapStateToProps = state => ({
  allModuleVolume: state.modules.allModuleVolume,
  moduleSchedule: state.modules.moduleSchedule
});

const mapDispatchToProps = dispatch => ({
  changeModuleSchedule: moduleSchedule =>
    dispatch(changeModuleScheduleAction(moduleSchedule))
});

export default connect(mapStateToProps, mapDispatchToProps)(CalendarSchedule);
